import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyA2gVwsCnutMHs2g0s6_uDa2UXhVwhoZPU",
  authDomain: "get-dynam.firebaseapp.com",
  databaseURL: "https://get-dynam.firebaseio.com",
  projectId: "get-dynam",
  storageBucket: "get-dynam.appspot.com",
  messagingSenderId: "1004823447723",
  appId: "1:1004823447723:web:56673a30605622e1a6cfee",
  measurementId: "G-PDY3CL1Q50",
};

firebase.initializeApp(config);
